import api from '@/apis/di/autoBusinessAPI';
import Crud from '@/stores/crudBase';
import { ModuleAutoBusinessCache } from '@/stores/moduleConst';
import store from '@/stores/store';
var crud = new Crud('autoBusiness', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_auto_business',
    field: {
      key: 'auto_business_id',
      // code: 'auto_business_name',
      name: 'auto_business_name',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  /**
   * Đồng bộ sang dữ liệu cache combo
   * @param {*} state
   * @param {*} items
   * NXCHIEN 06.02.2024
   */
  deleteItems: (state, items) => {
    crud.mutations.deleteItems(state, items);
    store.dispatch(`${ModuleAutoBusinessCache}/deleteItemCombo`, items);
  },
  insertItem: (state, item) => {
    crud.mutations.insertItem(state, item);
    let res = {
      auto_business_id: item.auto_business_id,
      auto_business_name: item.auto_business_name,
      ref_type: item.ref_type,
      inactive: item.inactive
    }
    store.dispatch(`${ModuleAutoBusinessCache}/insertItemCombo`, res);
  },
  updateItem: (state, item) => {
    crud.mutations.updateItem(state, item);
    let res = {
      auto_business_id: item.auto_business_id,
      auto_business_name: item.auto_business_name,
      ref_type: item.ref_type,
      inactive: item.inactive
    }
    store.dispatch(`${ModuleAutoBusinessCache}/updateItemCombo`, res);
  },
  updateItemQuickFllow: (state, item) => {
    crud.mutations.updateItemQuickFllow(state, item);
    let res = {
      auto_business_id: item.auto_business_id,
      auto_business_name: item.auto_business_name,
      ref_type: item.ref_type,
      inactive: item.inactive
    }
    store.dispatch(`${ModuleAutoBusinessCache}/updateItemQuickFllowCombo`, res);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
